<template src="./EditUserPermissions.html"/>

<script>
import mixins from "@/Mixins.js"
export default {
  mixins: [mixins],
  mounted() {
    this.id = this.$route.params.id
    this.getUser()
    this.getSystems()
    this.details = this.$store.state.detailsSystem
    if (Array.isArray(this.details) && this.details.length === 0) 
      this.getFunc(this.id)
  },
  data() {
    return {
      details: [],
      id: "",
      user: "",
      systems: [],
      systemUser: [],
      groupUsers: [],
      date: {
        start: "",
        end: ""
      },
      idSystem: "",
      activePrompt2: false,
      activePrompt3: false,
      activePrompt4:false,
      activePrompt: false,
      activeUpdate: false,
      functionalities: "",
      systemsFunc: "",
      colorx: "FFA500",
      val: "",
      valMultipe: {
        value1: "",
        value2: ""
      },
      selectFunction: [],
      selectGroup: [],
      sytemsId: [],
      groupId: [],
      dateInitial: "",
      dateFinal: "",
      systemSelectedName: "Nenhum sistema selecionado",
      itemId: "",
      dateInitialValidity: "",
      dateFinalValidity: "",
      invalidFields: {
        initialDate: false,
        initialDateValidity: false,
        finalDate: false,
        finalDateValidity: false
      },
      removeModal: false,
      isGroup: false,
      removeMessage: "",
      messageName:"",
    }
  },
  computed: {
    existFunc() {
      return !(this.selectFunction.length > 0)
    },
    existGroup() {
      return !(this.selectGroup.length > 0)
    },
    existgroupUsers() {
      return !(this.groupUsers.length > 0)
    }
  },
  watch: {
    dateInitialValidity: function(newVal) {
      this.invalidFields.initialDateValidity = this.validateInitialDate(newVal, this.dateFinalValidity)
      this.invalidFields.finalDateValidity = this.validateFinalDate(newVal, this.dateFinalValidity)
    },
    dateInitial: function(newVal) {
      this.invalidFields.initialDate = this.validateInitialDate(newVal, this.dateFinal)
      this.invalidFields.finalDate = this.validateFinalDate(newVal, this.dateFinal)
    },
    dateFinal: function(newVal) {
      this.invalidFields.initialDate = this.validateInitialDate(this.dateInitial, newVal)
      this.invalidFields.finalDate = this.validateFinalDate(this.dateInitial, newVal)
    },
    dateFinalValidity: function(newVal) {
      this.invalidFields.initialDateValidity = this.validateInitialDate(this.dateInitialValidity, newVal)
      this.invalidFields.finalDateValidity = this.validateFinalDate(this.dateInitialValidity, newVal)
    },
  },
  methods: {
    back() {
      this.$router.push("/manage-permissions")
    },
    getNoFunction() {
      (this.sytemsId = []), (this.groupId = []), (this.activePrompt2 = true)
      this.getNotparams()
    },
    addFunc() {
      this.$vs.loading({
        container: this.$refs.content,
        scale: 0.5
      })
      let params = {
        functionalities: [],
        groups: []
      }
      this.groupId.forEach( element => {
        params.groups.push({
          id: element,
          start: this.dateInitial,
          end: this.dateFinal,
          source: "gateway"
        })
      })
      this.sytemsId.forEach( element => {
        params.functionalities.push({
          id: element,
          start: this.dateInitial,
          end: this.dateFinal,
          source: "gateway"
        })
      })
      this.axios
        .put(
          this.$store.state.filooServer +
            `access/users/${this.id}/systems/${this.idSystem}`,
          params,
          {
            headers: { Authorization: this.$session.get("bearer") }
          }
        )
        .then( response => {
          if (response.status === 200) {
            this.$vs.loading.close(this.$refs.content)
            this.activePrompt2 = false
            this.$swal(
              "Operação realizada",
              "Permissões atualizadas com sucesso!",
              "success"
            )
            this.getSystemFunctionalities(
              this.idSystem,
              this.systemSelectedName
            )
            this.activePrompt2 = false
          }
        })
        .catch( () => {
          this.$vs.loading.close(this.$refs.content)
        })
        .finally( () => {
          this.getFunc(this.id)
          this.getUser()
        })
    },
    getNotparams() {
      this.$vs.loading({
        container: this.$refs.content,
        scale: 0.5
      })
      this.axios
        .get(
          this.$store.state.filooServer +
            `access/users/${this.id}/systems/${this.idSystem}/functionalities/source/gateway`,
          {
            headers: { Authorization: this.$session.get("bearer") }
          }
        )
        .then( response => {
          if (response.status === 200) {
            this.selectFunction = response.data.functionalities
            this.selectGroup = response.data.groups
            this.$vs.loading.close(this.$refs.content)
          }
        })
        .catch( () => {
          this.$vs.loading.close(this.$refs.content)
        })
    },
    updateDateFunctionality(item) {
      this.messageName = "Atualizar periodo de vigência: " + item.functionality.name
      this.dateInitialValidity = item.start
      this.dateFinalValidity = item.end
      this.itemId = item.id
      this.activePrompt3 = true
      this.activeUpdate = true
    },
    updateDateGroupsValidaty(item) {
      this.messageName = "Atualizar periodo de vigência: " + item.group.name
      this.dateInitialValidity = item.start
      this.dateFinalValidity = item.end
      this.itemId = item.id
      this.activePrompt4 = true
      this.activeUpdate = true
    },
    updateDateGroups() {
      const params = {
        start: this.dateInitialValidity,
        end: this.dateFinalValidity
      }
      this.axios
        .put(
          this.$store.state.filooServer +
            `access/users/${this.id}/systems/groups/${this.itemId}`,
          params,
          {
            headers: { Authorization: this.$session.get("bearer") }
          }
        )
        .then( response => {
          if (response.status === 204) {
            this.$swal(
              "Sucesso",
              "Data de vigência atualizada!",
              "success"
            )
            this.getSystemFunctionalities(
              this.idSystem,
              this.systemSelectedName
            )
          }
        })
        .finally(() => {
          this.$vs.loading.close(this.$refs.content)
          this.activeUpdate = false
          this.activePrompt4 = false
        })
    },
    updateDateFunc() {
      const params = {
        start: this.dateInitialValidity,
        end: this.dateFinalValidity
      }
      this.axios
        .put(
          this.$store.state.filooServer +
            `access/users/${this.id}/systems/functionalities/${this.itemId}`,
          params,
          {
            headers: { Authorization: this.$session.get("bearer") }
          }
        )
        .then( response => {
          if (response.status === 204) {
            this.$swal(
              "Sucesso",
              "Data de vigência atualizada!",
              "success"
            )
            this.$vs.loading.close(this.$refs.content)
            this.getSystemFunctionalities(
              this.idSystem,
              this.systemSelectedName
            )
          }
        })
        .finally( () => {
          this.$vs.loading.close(this.$refs.content)
          this.activeUpdate = false
          this.activePrompt3 = false
        })
    },
    removeConfirmed() {
      this.isGroup ? this.delGroup() : this.delFunc()
    },
    showRemoveModal(item, isGroup) {
      this.removeMessage = "Você tem certeza que deseja excluir"
      this.itemId = item.id
      this.removeMessage = isGroup ? this.removeMessage + " o grupo:" : this.removeMessage + " a funcionalidade:"
      this.messageName = isGroup ? item.group.name : item.functionality.name
      this.isGroup = isGroup
      this.removeModal = true
      this.$nextTick(() => { this.focusInput() })
    },
    delFunc() {
      this.$vs.loading({
        container: this.$refs.content,
        scale: 0.5
      })
      this.axios
        .delete(
          this.$store.state.filooServer +
            `access/users/${this.id}/systems/functionalities/${this.itemId}`,
          {
            headers: { Authorization: this.$session.get("bearer") }
          }
        )
        .then( () => {
          this.$swal(
            "Sucesso",
            "Funcionalidade deletada com sucesso!",
            "success"
          )
          this.$vs.loading.close(this.$refs.content)
          this.getSystemFunctionalities(
            this.idSystem,
            this.systemSelectedName
          )
        })
        .catch( (err) => {
          if (err.status === 204) this.$swal("Sucesso", "Funcionalidade deletada com sucesso!", "success")
          else this.$swal("Atenção", "A funcionalidade não pode ser excluída!", "warning")
          this.$vs.loading.close(this.$refs.content)
          this.getSystemFunctionalities(
            this.idSystem,
            this.systemSelectedName
          )
        })
        .finally( () => {
          this.removeModal = false
          this.getFunc(this.id)
          this.getUser()
        })
    },
    delGroup() {
      this.$vs.loading({
        container: this.$refs.content,
        scale: 0.5
      })
      this.axios
        .delete(
          this.$store.state.filooServer +
            `access/users/${this.id}/systems/groups/${this.itemId}`,
          {
            headers: { Authorization: this.$session.get("bearer") }
          }
        )
        .then( () => {
          this.$swal(
            "Sucesso",
            "Grupo deletado com sucesso!",
            "success"
          )
          this.$vs.loading.close(this.$refs.content)
          this.getSystemFunctionalities(
            this.idSystem,
            this.systemSelectedName
          )
        })
        .finally(function () {
          this.$vs.loading.close(this.$refs.content)
          this.removeModal = false
        })
    },
    openConfirm() {},
    getSystemFunctionalities(id, name) {
      this.idSystem = id
      this.systemSelectedName = name
      this.$vs.loading({
        container: this.$refs.content,
        scale: 0.5
      })
      this.axios
        .get(
          this.$store.state.filooServer +
            `access/users/${this.id}/systems/${id}/source/gateway`,
          {
            headers: { Authorization: this.$session.get("bearer") }
          }
        )
        .then( response => {
          if (response.status === 200) {
            this.$vs.loading.close(this.$refs.content)
            this.systemsFunc = response.data
            this.functionalities = response.data.functionalities
            this.groupUsers = response.data.groups
          }
        })
        .catch( () => {
          this.$vs.loading.close(this.$refs.content)
        })
    },
    getSystems() {
      this.$vs.loading({
        container: this.$refs.content,
        scale: 0.5
      })
      this.axios
        .get(this.$store.state.filooServer + "access/systems/source/gateway", {
          headers: { Authorization: this.$session.get("bearer") }
        })
        .then( response => {
          if (response.status === 200) {
            this.systems = response.data
            this.$vs.loading.close(this.$refs.content)
          }
        })
    },
    getUser() {
      this.$vs.loading({
        container: this.$refs.content,
        scale: 0.5
      })
      this.axios
        .get(this.$store.state.filooServer + `access/users/${this.id}/source/gateway`, {
          headers: { Authorization: this.$session.get("bearer") }
        })
        .then( response => {
          if (response.status === 200) {
            this.user = response.data
            this.systemUser = response.data.systems
            this.$vs.loading.close(this.$refs.content)
          }
        })
        .catch( () => {
          this.$vs.loading.close(this.$refs.content)
        })
    },
    updateDate() {
      if(this.activePrompt3) this.updateDateFunc()
      else if(this.activePrompt4) this.updateDateGroups()
    },
    closeUpdate() {
      this.activeUpdate = false
      if(this.activePrompt3) this.activePrompt3 = !this.activePrompt3
      else if(this.activePrompt4) this.activePrompt4 = !this.activePrompt4
    },
    isAllDatesNull(dateStart, dateFinal) {
      return this.testNullUndefinedEmpty(dateStart) && this.testNullUndefinedEmpty(dateFinal)
    },
    validateInitialDate(dateStart, dateFinal) {
      if(this.isAllDatesNull(dateStart, dateFinal)) return false
      return this.testNullUndefinedEmpty(dateStart)
       ? !this.testNullUndefinedEmpty(dateFinal) 
       : new Date(dateStart) < new Date(new Date().setDate(new Date().getDate() - 1))
    },
    validateFinalDate(dateStart, dateFinal) {
      if(this.isAllDatesNull(dateStart, dateFinal )) return false
      if(!this.testNullUndefinedEmpty(dateFinal) && !this.testNullUndefinedEmpty(dateStart)) 
        return new Date(dateFinal) < new Date(dateStart)
      return !(this.testNullUndefinedEmpty(dateFinal) && this.testNullUndefinedEmpty(dateStart))
    },
    focusInput() {
      window.setTimeout(function ()
      {
        document.getElementById("buttonNo").focus()
      }, 0)
		},
    getFunc(id) {
      this.axios
        .get(this.$store.state.filooServer + `access/users/${id}/systems/source/gateway`, {
          headers: {
            Authorization: this.$session.get("bearer")
          }
        })
        .then(response => {
          if (response.status === 200) {
            const func = [];
            const funcs = response.data
            response.data.forEach(element => {
              func.push(element.url);
            });
            let funcSystem = funcs.reduce((r, a) => {
              r[a.nomeSistema] = [...r[a.nomeSistema] || [], a];
              return r
            }, {})
            this.$store.commit("PERMISSION_SYSTEM", func);
            this.$store.commit("DETAILS_SYSTEMS", funcSystem);
            this.details = funcSystem
            }
        });
    },
  }
}
</script>

<style lang="scss" src="./EditUserPermissions.scss"/>